import React from "react";
import { motion } from "framer-motion";

const TableRow = ({ data, columns, onEdit, onDelete, index, currentUserId = null }) => {
  const isCurrentUser = currentUserId != null && String(data.id) === String(currentUserId);
  const showDelete = onDelete && !isCurrentUser;
  return (
    <motion.tr
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: Math.min(index, 12) * 0.03 }}
      className="border-b border-line last:border-b-0 hover:bg-hover transition-colors"
    >
      {columns.map((column, colIndex) => (
        <td
          key={colIndex}
          className="px-5 py-3.5 text-[13.5px] text-ink"
        >
          {column.render
            ? column.render(data[column.key], data)
            : data[column.key]}
        </td>
      ))}
      {(onEdit || onDelete) && (
        <td className="px-5 py-3.5 text-sm">
          <div className="flex items-center justify-end gap-1">
            {onEdit && (
              <motion.button
                whileTap={{ scale: 0.95 }}
                onClick={() => onEdit(data)}
                className="p-2 rounded-lg text-faint hover:text-accent hover:bg-accent-soft transition-colors"
                title="Edit"
                aria-label="Edit"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth={1.9}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </motion.button>
            )}
            {showDelete && (
              <motion.button
                whileTap={{ scale: 0.95 }}
                onClick={() => onDelete(data)}
                className="p-2 rounded-lg text-faint hover:text-danger hover:bg-danger-soft transition-colors"
                title="Delete"
                aria-label="Delete"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth={1.9}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </motion.button>
            )}
          </div>
        </td>
      )}
    </motion.tr>
  );
};

export default TableRow;
